<template>
    <v-dialog width="900px" v-model="translateDialog">
         <v-btn slot="activator" fab dark small color="blue" ><v-icon>translate</v-icon> 
        </v-btn>
        <v-card color="grey lighten-4" flat offset-md4 >
      <v-container grid-list-md pa-3>
                 
        <v-layout row wrap>
          <v-flex xs11>
            <div style="color: purple; text-align:center; margin-top:2%"><h2>Translate  </h2></div>
          </v-flex>
          <v-flex xs1 style="">
              <v-btn flat fab small @click="translateDialog=false;"> <v-icon>close</v-icon></v-btn>
          </v-flex>
        <v-layout column wrap pa-3>
            <v-flex xs6 text-xs-center>
                <v-text-field
                 label="Language"
                :value="language"
                readonly>
                </v-text-field>
              
            </v-flex>
            <v-flex xs6>
                <v-text-field
                id="tit"
                name="title"
                label="Title"
                :value="pic.infoPtitle"
                readonly
                >   
                </v-text-field>
                
            </v-flex>
            <v-flex xs6>
                  <v-text-field
                id="abbr"
                name="abbr"
                label="Abbreviation"
                :value="pic.infoPAbbr"
                readonly
                >   
                </v-text-field>
            </v-flex>
            <v-flex xs6>
                  <v-text-field
                id="period"
                name="period"
                label="Period"
                :value="pic.infoPPeriod"
                readonly
                >   
                </v-text-field>
            </v-flex>
            <v-flex xs6>
                <img  :src="imageUrlStart"  height="150">        
            </v-flex>
              <v-flex xs6>
                  <v-text-field
                id="source"
                name="source"
                label="Source"
                :value="pic.infoPSource"
                readonly
                >   
                </v-text-field>
            </v-flex>

        </v-layout>
                  <v-layout column wrap pa-3>
            <v-flex xs6 >
               <v-select
               label="Translate in"
               :items="langs"
               v-model="langTobeTranslated">

               </v-select>
            </v-flex>
            <v-flex xs6>
                <v-text-field
                id="tit"
                name="title"
                label="Translate title"
                v-model="translatedTitle"
                 :disabled="avLang"
                >   
                </v-text-field>
                
            </v-flex>
            <v-flex xs6>
                  <v-text-field
                id="abbr"
                name="abbr"
                label="Translate abbreviation"
                v-model="translatedAbbr"
                 :disabled="avLang"
                >   
                </v-text-field>
            </v-flex>
            <v-flex xs6>
                  <v-text-field
                id="period"
                name="period"
                label="Translate Period"
                v-model="translatedPeriod"
                 :disabled="avLang"
                >   
                </v-text-field>
            </v-flex>
            <v-flex xs6>
                <v-btn raised class="primary "  :disabled="avLang" v-model="translatedPic"  @click="onPickFile">Upload Image</v-btn>
                <input type="file" style="display: none"   ref="fileInput" accept="image/*" @change="onFilePicked">         
                 <v-flex xs12 sm6 offset-sm3>
                        <img :src="imageUrl"  height="150">    
                 </v-flex>
                </v-flex>
              <v-flex xs6>
                  <v-text-field
                id="source"
                name="source"
                label="Translate Source"
                v-model="translatedSource"
                 :disabled="avLang"
                >   
                </v-text-field>
            </v-flex>

        </v-layout>

      <div style="margin-left:44%;">
            <v-spacer></v-spacer>
          <v-btn @click="onSubmitChanges" color="red" style="color:white;" 
          :disabled="!formIsValid"
          > Translate Picture </v-btn>
</div>
        </v-layout>
      </v-container>
    </v-card>
    </v-dialog>
 

</template>

<script>
export default {
  props: ["pic", "types"],
  data() {
    return {
      langTobeTranslated: "",
      langType: [1, 2],
      translateDialog: false,
      translatedTitle: "",
      translatedAbbr: "",
      translatedPeriod: "",
      translatedPic: null,
      translatedSource: "",
      id: this.pic.id,
      imageUrl: this.pic.infoPicture,
      imageUrlStart:this.pic.infoPicture,
            imageName:"",
    };
  },
  computed: {
    language() {
      if (this.pic.infoTLang === 1) {
        return "English";
      } else if (this.pic.infoPLang === 2) {
        return "Greek";
      }
    },
    avLang(){
        if (this.langTobeTranslated ===""){
            return true;
        }else{
            return false;
        }
    },
    formIsValid() {
      return (
        this.translatedTitle !== "" && this.translatedDesc !== "" && this.langTobeTranslated
      );
    },
    langs() {
      var langTypes = [];
      for (let index = 0; index < this.types.length; index++) {
        if (
          this.pic.infoPSchType === this.types[index].sch &&
          this.pic.infoPID === this.types[index].id &&
          this.pic.interestPoint === this.types[index].point
        ) {
          langTypes.push(this.types[index].lang);
        }
        for (let index = 0; index < langTypes.length; index++) {
          var i = this.langType.indexOf(langTypes[index]);
          if (i > -1) {
            this.langType.splice(i, 1);
          }
        }
      }
      var langNames=["English","Greek"];
    for (let index = 0; index < this.langType.length; index++) {
         this.langType[index] = langNames[this.langType[index]-1];
        
    }
      return this.langType;
    }
  },
  methods: {
    onSubmitChanges() {
      if (!this.formIsValid) {
        return;
      }
      if(this.langTobeTranslated === "Greek"){
          this.langTobeTranslated = 2;
      }else{
           this.langTobeTranslated = 1;
      }
      const picData = {
        infoPID: this.pic.infoPID,
        infoPtitle: this.translatedTitle,
        infoPAbbr: this.translatedAbbr,
        infoPPeriod: this.translatedPeriod,
         image: this.image,
         imageName:this.imageName,
         imageUrl: this.imageUrl,
        infoPSource: this.translatedSource,
        infoPSchType: this.pic.infoPSchType,
        interestPoint: this.pic.interestPoint,
        infoPLang: this.langTobeTranslated,
        createdBy: this.$store.getters.user.email
      };
      this.$store.dispatch("translatePic", picData);
      this.$store.dispatch("loadSpotContent", this.pic.interestPoint);
      this.translateDialog = false;
    },
    onPickFile(){
        this.$refs.fileInput.click()
      
    },
      onFilePicked (event) {
        const files = event.target.files
        let filename = files[0].name
        this.imageName = filename;
        if (filename.lastIndexOf('.') <= 0){
          return alert('Please add a valid file!')
        }
        const fileReader = new FileReader()
        fileReader.addEventListener('load', () => {
          this.imageUrl = fileReader.result
        })
        fileReader.readAsDataURL(files[0])
        this.image = files[0];
      }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/edit-pictures/translatePicture.vue